import { useRecoverPassword } from '@/api/user-manager'
import { useCountdown } from '@/hooks'
import { MarkEmailReadOutlined } from '@mui/icons-material'
import { Box, CircularProgress, Link, Typography } from '@mui/material'
import { useEffect } from 'react'

interface EmailSentProps {
  email: string
}

const SECONDS_TO_RESEND = 60

export function EmailSent({ email }: EmailSentProps) {
  const { mutateAsync: recoverPassword, isPending } = useRecoverPassword({
    onSuccess: () => startCountdown(),
  })

  const { count, startCountdown } = useCountdown({
    countStart: SECONDS_TO_RESEND,
  })

  function resubmitRecovery() {
    recoverPassword({ email, use_second_provider: true })
  }

  useEffect(() => {
    startCountdown()
  }, [])

  return (
    <Box
      height="50vh"
      maxWidth={360}
      margin="auto"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <MarkEmailReadOutlined
        sx={{ fontSize: 56, mb: 2, color: 'secondary.main' }}
      />

      <Typography variant="h3" align="center" mb={2}>
        E-mail de recuperação de senha enviado!
      </Typography>

      <Typography align="center">
        Enviamos um e-mail para <b>{email}</b>
      </Typography>

      <Typography align="center" mt={2}>
        Ainda não recebeu?
      </Typography>

      {isPending ? (
        <CircularProgress size={16} />
      ) : (
        <Typography align="center">
          {count === SECONDS_TO_RESEND ? (
            <Link onClick={resubmitRecovery}>Reenviar</Link>
          ) : (
            `Aguarde ${count} para reenviar.`
          )}
        </Typography>
      )}
    </Box>
  )
}
